import React, { useState } from 'react'
import { Progress } from 'antd';

const onboardingSteps = [
    { title: 'Basic Details', description: 'Company & contact info' },
    { title: 'Ad Formats', description: 'Formats & integration method' },
    { title: 'Compliance & Safety', description: 'Regulations & brand safety' },
    { title: 'Media Kit', description: 'Upload docs & define role', optional: true },
];

const TabsForms = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState([]);
    const progressPercent = Math.round((completedSteps.length / onboardingSteps.length) * 100);

    const selectStep = (stepIndex) => {
        if (stepIndex > activeStep) {
            setCompletedSteps((currentSteps) =>
                currentSteps.includes(activeStep) ? currentSteps : [...currentSteps, activeStep]
            );
        }

        setActiveStep(stepIndex);
    };

    return (
        <div className="tabs_forms" >
            <div className='tabs_div'>
                <div className='tabs_inner_div'>
                    <h5>Onboarding</h5>
                    <h4>You’re one step closer to activation</h4>

                    <div className='progress_bar_div'>
                        <div className='progress_bar_text'>
                            <span>Progress</span>
                            <p>{progressPercent}%</p>
                        </div>
                        <Progress percent={progressPercent} showInfo={false} />
                    </div>

                    <div className='custome_tabs_div'>
                        <nav className='onboarding_stepper' aria-label='Onboarding steps'>
                            {onboardingSteps.map((step, index) => {
                                const isComplete = completedSteps.includes(index);
                                const isActive = activeStep === index;

                                return (
                                    <button
                                        key={step.title}
                                        type='button'
                                        className={`onboarding_step ${isActive ? 'is-active' : ''} ${isComplete ? 'is-complete' : ''}`}
                                        onClick={() => selectStep(index)}
                                    >
                                        <span className='step_indicator' aria-hidden='true'>
                                            {isComplete ? <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                <path d="M10.8346 3.75L4.8763 9.70833L2.16797 7" stroke="white" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg> : <span className='step_dot' />}
                                        </span>
                                        <span className='step_content'>
                                            <span className='step_title'>
                                                {step.title} {step.optional && <small>(optional)</small>}
                                            </span>
                                            <span className='step_description'>{step.description}</span>
                                        </span>
                                        {isActive && <span className='step_arrow' aria-hidden='true'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="white" stroke-opacity="0.6" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span>}
                                    </button>
                                );
                            })}
                        </nav>
                    </div>

                </div>
            </div>
            <div className="container_box--wrapper pt_header">
                <div className='onboarding_tab_content'>
                    {activeStep === 0 && (
                        <div className='tab_form basic_details_form'>
                            ffdsaff
                        </div>
                    )}

                    {activeStep === 1 && (
                        <div className='tab_form ad_formats_form'>
                            sdfdsfsadfsdafadsf
                        </div>
                    )}

                    {activeStep === 2 && (
                        <div className='tab_form compliance_safety_form'>
                            dsfdsfsdafsadfdsafadsfdsaf
                        </div>
                    )}

                    {activeStep === 3 && (
                        <div className='tab_form media_kit_form'>
                            dsfdsafdsafasfadsfdsvcxvdfsgsfefadsfsda
                        </div>
                    )}
                </div>
            </div>
        </div >
    )
}

export default TabsForms
